import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-sme-group-view',
  templateUrl: './sme-group-view.component.html',
  styleUrls: ['./sme-group-view.component.scss'],
})
export class SmeGroupViewComponent implements OnInit {
  smes: any[];

  constructor() {}

  ngOnInit(): void {
    this.smes = [
      {
        id: 1,
        name: 'Vivaan Pradhan',
        userName: 'vivaanpradhan',
        groupName: 'SME Group 1',
        userImage: '',
        userGuard: true,
      },
      {
        id: 2,
        name: 'Aniket Lad',
        userName: 'aniketlad',
        groupName: 'SME Group 1',
        userImage: '',
        userGuard: false,
      },
      {
        id: 3,
        name: 'Advik Dora',
        userName: 'advikbora',
        groupName: 'SME Group 1',
        userImage: '',
        userGuard: true,
      },
      {
        id: 4,
        name: 'Atharv Bajaj',
        userName: 'atharvbajaj',
        groupName: 'SME Group 1',
        userImage: '',
        userGuard: false,
      },
      {
        id: 5,
        name: 'Manu Bath',
        userName: 'manubath',
        groupName: 'SME Group 1',
        userImage: '',
        userGuard: true,
      },
    ];
  }
}
